<div *ngIf='rowDirective && (!rowDirectiveLevels || item.level && rowDirectiveLevels.indexOf(item.level) >= 0)'></div>
<span class='toggle-icons'>
    <i *ngIf="item.hasChildren" class='fa fa-chevron-right margin-right-3' (click)='expandItem($event, item)'></i>
    <i *ngIf="item.hasChildren" class='fa fa-chevron-down' (click)='collapseItem($event, item)'></i>
    <i *ngIf="!item.hasChildren" class="margin-right-12"></i>
</span>

<input type='checkbox' id="{{item.value +'_'+ item.id}}" [disabled]="item.disabled" (click)='selectItem($event, item)'
    [ngModel]="item.checked || (item.indeterminate)" [checkboxIndeterminate]='item.indeterminate' />

<span>{{item.label || item.value}}</span>

<ul class="main-list unstyled" *ngIf='item.hasChildren'>
    <li class='checkbox-tree-item' [ngClass]="{'hasChildren' : item.hasChildren == true}"
        *ngFor='let item of item.children' [tree-template]="item" [expandItem]="expandItem.bind(this)"
        [collapseItem]="collapseItem.bind(this)" [selectItem]="selectItem.bind(this)"
        [toggleChildren]="toggleChildren.bind(this)" [rowDirective]="rowDirective"
        [rowDirectiveLevels]="rowDirectiveLevels"></li>
</ul>